import { useMemo } from "react";
import { useAppDispatch, useAppSelector } from ".";
import { Content, MenuSection } from "@/types";
import { setSelectedMenuItem } from "@/store/uiSlice";

interface Props {
  structure?: MenuSection[];
  content?: Content[];
}

const useDishNavigation = ({ structure = [], content = [] }: Props) => {
  const dispatch = useAppDispatch();
  const selectedDish = useAppSelector((state) => state.ui?.selectedMenuItem) as unknown as Content;

  const sortedDishes = useMemo(() => {
    return structure.reduce((acc, curr) => {
      const items = content.filter((c) => c.category === curr.category);
      return [...acc, ...items];
    }, [] as unknown as Content[]);
  }, [content, structure]);

  const onContinue = () => {
    const selectedIndex = sortedDishes.findIndex((d) => d.id === selectedDish?.id);
    const isLastItem = selectedIndex === sortedDishes.length - 1;
    if (!isLastItem) {
      dispatch(setSelectedMenuItem(sortedDishes[selectedIndex + 1]));
    }
  };

  const onBack = () => {
    const selectedIndex = sortedDishes.findIndex((d) => d.id === selectedDish?.id);
    const isFirstItem = selectedIndex === 0;
    if (!isFirstItem) {
      dispatch(setSelectedMenuItem(sortedDishes[selectedIndex - 1]));
    }
  };

  return {
    onContinue,
    onBack,
  };
};

export default useDishNavigation;
